import { IndustrialProcessSchema, IndustrialProcessType } from "../types";
import { assertUnreachable } from "./assertUnreachable";

export const isFlatPriceProcess = (industrialProcess: IndustrialProcessType | undefined) => {
  if (!industrialProcess) {
    return false;
  }

  switch (industrialProcess) {
    case IndustrialProcessSchema.enum.ASSEMBLING:
      return false;
    case IndustrialProcessSchema.enum.PACKING:
      return false;
    case IndustrialProcessSchema.enum.LASER_CUT:
      return false;
    case IndustrialProcessSchema.enum.WATER_CUT:
      return false;
    case IndustrialProcessSchema.enum.PLASMA_CUT:
      return false;
    case IndustrialProcessSchema.enum.WELDING:
      return false;
    case IndustrialProcessSchema.enum.SHEARING:
      return false;
    case IndustrialProcessSchema.enum.PUNCHING:
      return false;
    case IndustrialProcessSchema.enum.FOLDING:
      return false;
    case IndustrialProcessSchema.enum.BENDING:
      return false;
    case IndustrialProcessSchema.enum.ROLLING:
      return false;
    case IndustrialProcessSchema.enum.SURFACE_TREATMENT:
      return true;
    case IndustrialProcessSchema.enum.HEAT_TREATMENT:
      return true;
    case IndustrialProcessSchema.enum.MILLING:
      return false;
    case IndustrialProcessSchema.enum.DRILLING:
      return false;
    case IndustrialProcessSchema.enum.TURNING:
      return false;
    case IndustrialProcessSchema.enum.TRANSPORT:
      return true;
    case IndustrialProcessSchema.enum.OTHER:
      return false;
    case IndustrialProcessSchema.enum.CRIMPING:
      return false;
    case IndustrialProcessSchema.enum.ELECTRO_EROSION:
      return false;
    case IndustrialProcessSchema.enum.GRINDING:
      return false;
    case IndustrialProcessSchema.enum.PRESSING:
      return false;
    case IndustrialProcessSchema.enum.RIVETING:
      return false;
    case IndustrialProcessSchema.enum.SAWING:
      return false;
    case IndustrialProcessSchema.enum.ENGRAVING:
      return false;
    case IndustrialProcessSchema.enum.CONTROL:
      return false;
    case IndustrialProcessSchema.enum.COUNTERSINKING:
      return false;
    case IndustrialProcessSchema.enum.PRODUCTS:
      return false;
    case IndustrialProcessSchema.enum.OUTSOURCING:
      return true;
    case IndustrialProcessSchema.enum.MATERIAL:
      return false;
    case IndustrialProcessSchema.enum.SIMPLE:
      return true;
    case IndustrialProcessSchema.enum.CHIMIC_ENGRAVING:
      return false;
    case IndustrialProcessSchema.enum.COMBINED_PUNCHING_LASER:
      return false;
    case IndustrialProcessSchema.enum.DEBURRING:
      return false;
    case IndustrialProcessSchema.enum.UNSTAPLING:
      return false;
    case IndustrialProcessSchema.enum.TAPPING:
      return false;
    case IndustrialProcessSchema.enum.TRIMMING:
      return false;

    default:
      assertUnreachable(industrialProcess);
  }
};
